import TimetableFunction from '../timetable/timetableFunction';

class BattleshipMove {
    changeType;
    changeIndex;

    objectId;
    objectTypeId;

    timeIn;
    weekDayId;
    label;

    functionId;

    instructorIds: Array<number>;

    roomId: number | null;
    fromBuildingObjectId: number | null;
    toBuildingObjectId: number | null;
    fromCourseObjectId: number | null;
    toInstructorObjectId: number | null;
    timetableFunctions: Array<TimetableFunction>;

    constructor(
        changeType: number,
        changeIndex: number,
        objectId: number,
        objectTypeId: number,
        timeIn: string,
        weekDayId: number,
        label: string,
        functionId: number,
        instructorIds: Array<number>,
        roomId: number | null,
        fromBuildingObjectId: number | null,
        toBuildingObjectId: number | null,
        fromCourseObjectId: number | null,
        toInstructorObjectId: number | null,
        timetableFunctions: Array<TimetableFunction>,
    ) {
        this.changeType = changeType;
        this.changeIndex = changeIndex;
        this.objectId = objectId;
        this.objectTypeId = objectTypeId;
        this.timeIn = timeIn;
        this.weekDayId = weekDayId;
        this.label = label;
        this.functionId = functionId;
        this.instructorIds = instructorIds;
        this.roomId = roomId;
        this.fromBuildingObjectId = fromBuildingObjectId;
        this.toBuildingObjectId = toBuildingObjectId;
        this.fromCourseObjectId = fromCourseObjectId;
        this.toInstructorObjectId = toInstructorObjectId;
        this.timetableFunctions = timetableFunctions;
    }
}

export default BattleshipMove;
